<template>
    <div class="approved-list">
      <!-- 搜索和筛选 -->
      <el-form :inline="true" class="search-form" size="small">
        <el-form-item label="项目名称">
          <el-input
            v-model="searchForm.workName"
            placeholder="搜索项目名称"
            clearable
            @clear="handleSearch"
          />
        </el-form-item>
        <el-form-item label="审批人">
          <el-input
            v-model="searchForm.reviewUser"
            placeholder="搜索审批人"
            clearable
            @clear="handleSearch"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" :loading="loading">
            搜索
          </el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
  
      <!-- 申请列表 -->
      <el-table
        :data="applyList"
        border
        v-loading="loading"
        class="apply-table"
        @sort-change="handleSortChange"
      >
        <el-table-column prop="id" label="申请ID" width="80" sortable="custom" />
        <el-table-column prop="WorkName" label="项目名称" min-width="150" show-overflow-tooltip />
        <el-table-column prop="build_company" label="建设单位" min-width="120" show-overflow-tooltip />
        <el-table-column label="修改内容" min-width="100">
          <template slot-scope="scope">
            <el-tag size="small" type="info">
              修改{{ scope.row.changedCount || 0 }}项
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="applyUserName" label="申请人" width="100">
          <template slot-scope="scope">
            {{ scope.row.applyUserName || '用户' + scope.row.apply_user_id }}
          </template>
        </el-table-column>
        <el-table-column prop="apply_time" label="申请时间" width="150" sortable="custom">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.apply_time) }}
          </template>
        </el-table-column>
        <el-table-column prop="reviewUserName" label="审批人" width="100">
          <template slot-scope="scope">
            {{ scope.row.reviewUserName || (scope.row.review_user_id ? '用户' + scope.row.review_user_id : '-') }}
          </template>
        </el-table-column>
        <el-table-column prop="review_time" label="审批时间" width="150">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.review_time) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="handleViewDetail(scope.row)"
            >
              查看详情
            </el-button>
            <el-button
              type="text"
              size="mini"
              style="color: #409EFF"
              @click="handleViewContract(scope.row)"
            >
              查看合同
            </el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        class="pagination"
      />
  
    </div>
  </template>
  
  <script>
  import { getContractApplyList } from '../api';
  import { mapGetters } from 'vuex';
  
  export default {
    name: 'ApprovedList',
    
    data() {
      return {
        loading: false,
        applyList: [],
        
        // 搜索表单
        searchForm: {
          workName: '',
          reviewUser: ''
        },
        
        // 分页
        pagination: {
          current: 1,
          size: 10,
          total: 0
        },
        
        // 排序
        sortField: 'review_time',
        sortOrder: 'desc',
        
      };
    },
    
    computed: {
      ...mapGetters(['userId'])
    },
    
    created() {
      this.loadData();
    },
    
    methods: {
      // 加载数据
      async loadData() {
        this.loading = true;
        try {
          const params = {
            page: this.pagination.current,
            limit: this.pagination.size,
            status: 1, // 已通过状态
            roleId: 1 // 管理员权限
          };
          
          // 添加搜索条件
          if (this.searchForm.workName) {
            params.workName = this.searchForm.workName;
          }
          if (this.searchForm.reviewUser) {
            params.reviewUser = this.searchForm.reviewUser;
          }
          
          // 添加排序
          if (this.sortField) {
            params.field = this.sortField;
            params.order = this.sortOrder;
          }
          
          const res = await getContractApplyList(params);
          
          if (res.code === 0) {
            this.applyList = res.data || [];
            this.pagination.total = res.count || 0;
          } else {
            this.$message.error(res.msg || '加载失败');
          }
        } catch (error) {
          console.error('加载已通过列表失败:', error);
          this.$message.error('加载失败');
        } finally {
          this.loading = false;
        }
      },
      
      // 搜索
      handleSearch() {
        this.pagination.current = 1;
        this.loadData();
      },
      
      // 重置搜索
      resetSearch() {
        this.searchForm = {
          workName: '',
          reviewUser: ''
        };
        this.pagination.current = 1;
        this.loadData();
      },
      
      // 排序变化
      handleSortChange({ prop, order }) {
        if (prop && order) {
          this.sortField = prop;
          this.sortOrder = order === 'ascending' ? 'asc' : 'desc';
        } else {
          this.sortField = 'review_time';
          this.sortOrder = 'desc';
        }
        this.loadData();
      },
      
      // 分页大小变化
      handleSizeChange(size) {
        this.pagination.size = size;
        this.pagination.current = 1;
        this.loadData();
      },
      
      // 当前页变化
      handleCurrentChange(current) {
        this.pagination.current = current;
        this.loadData();
      },
      
      // 查看详情
      handleViewDetail(row) {
        this.$emit('show-detail', {
          applyId: row.id,
          canApprove: false
        });
      },
      
      // 查看合同
      handleViewContract(row) {
        this.$router.push({
          path: '/yj/work',
          query: { 
            highlightId: row.contract_id,
            view: 'detail'
          }
        });
      },
      
      // 获取修改的字段列表
      getChangedFields(apply) {
        if (!apply.modify_data) return [];
        
        try {
          const modifyData = JSON.parse(apply.modify_data);
          const changedFields = modifyData.changedFields || [];
          
          // 字段名映射
          const fieldNameMap = {
            'WorkName': '项目名称',
            'ReturnId': '归档编号',
            'content': '服务内容',
            'build_company': '建设单位',
            'DeadLine': '截止时间',
            'win_company': '中标单位',
            'FirstPrice': '招标控制价',
            'SecondPrice': '中标价',
            'HtPrice': '合同金额',
            'PayPrice': '已开票金额',
            'PingPrice': '评委费',
            'note': '备注'
          };
          
          return changedFields.map(field => fieldNameMap[field] || field);
        } catch (error) {
          console.error('解析修改字段失败:', error);
          return [];
        }
      },
      
      // 格式化日期时间
      formatDateTime(datetime) {
        if (!datetime) return '-';
        const date = new Date(datetime);
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
      }
    }
  };
  </script>
  
  <style scoped>
  .approved-list {
    padding: 10px;
  }
  
  .search-form {
    margin-bottom: 15px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #ebeef5;
  }
  
  .apply-table {
    margin-bottom: 15px;
    font-size: 13px;
  }
  
  .pagination {
    text-align: right;
    padding: 10px 0;
  }
  
  .dialog-footer {
    text-align: right;
  }
  
  .field-list {
    margin: 0;
    padding-left: 20px;
  }
  
  .field-list li {
    margin: 5px 0;
    color: #909399;
    font-size: 13px;
  }
  
  /* 响应式适配 */
  @media screen and (max-width: 768px) {
    .search-form {
      padding: 10px;
    }
    
    .apply-table {
      font-size: 12px;
    }
    
    ::v-deep .el-table__cell {
      padding: 4px 0;
    }
    
    ::v-deep .el-button--mini {
      padding: 4px 8px;
      font-size: 12px;
    }
    
  }
  </style>